import { ROUTE_PATHS } from '@/shared/config/router/types';
import {
  getCloudStorageValue,
  setCloudStorageValue,
} from '@/shared/helpers/cloud-storage';

import { NEW_GAMES_INDICATOR_TIMER, TWO_DAYS_IN_MS } from '../constants';
import { getVisitedTabIndicatorKey } from './getVisitedTabIndicatorKey';

// Check and update the new games indicator:
// retrieve the stored timestamp,
// and if two days have passed and the current pathname is not the games route,
// then reset the indicator.
export const updateNewGamesIndicatorIfNeeded = async (pathname: string) => {
  const storedTimestamp = await getCloudStorageValue(NEW_GAMES_INDICATOR_TIMER);
  const currentTimestamp = Date.now();

  if (!storedTimestamp) {
    await setCloudStorageValue(NEW_GAMES_INDICATOR_TIMER, `${currentTimestamp}`);
    return;
  }

  const diff = currentTimestamp - Number(storedTimestamp);
  if (diff >= TWO_DAYS_IN_MS && pathname !== ROUTE_PATHS.MAIN) {
    await setCloudStorageValue(
      getVisitedTabIndicatorKey(ROUTE_PATHS.MAIN.substring(1)),
      'false'
    );
    await setCloudStorageValue(NEW_GAMES_INDICATOR_TIMER, `${currentTimestamp}`);
  }
};
